import { Suit } from '@callbridge/engine';
import { colors } from '../theme/colors.js';
/**
 * SVG path data for card suit symbols.
 * These are standard playing card pips.
 */
export const suitPaths = {
    [Suit.Spades]: 'M12 2 C12 2 4 10 4 14 C4 17.3 6.7 20 10 20 C10.7 20 11.4 19.8 12 19.5 C12.6 19.8 13.3 20 14 20 C17.3 20 20 17.3 20 14 C20 10 12 2 12 2 Z M10 22 L14 22 L13 20 L11 20 Z',
    [Suit.Hearts]: 'M12 21.35 L10.55 20.03 C5.4 15.36 2 12.28 2 8.5 C2 5.42 4.42 3 7.5 3 C9.24 3 10.91 3.81 12 5.09 C13.09 3.81 14.76 3 16.5 3 C19.58 3 22 5.42 22 8.5 C22 12.28 18.6 15.36 13.45 20.04 L12 21.35 Z',
    [Suit.Diamonds]: 'M12 2 L22 12 L12 22 L2 12 Z',
    [Suit.Clubs]: 'M12 2 C9.8 2 8 3.8 8 6 C8 7.5 8.7 8.8 9.8 9.5 C8.1 9.2 6 10.8 6 13 C6 15.2 7.8 17 10 17 C10.7 17 11.4 16.8 12 16.5 C12.6 16.8 13.3 17 14 17 C16.2 17 18 15.2 18 13 C18 10.8 15.9 9.2 14.2 9.5 C15.3 8.8 16 7.5 16 6 C16 3.8 14.2 2 12 2 Z M10 19 L14 19 L13 17 L11 17 Z',
};
/**
 * Unicode characters for card suits.
 */
export const suitSymbols = {
    [Suit.Spades]: '♠',
    [Suit.Hearts]: '♥',
    [Suit.Diamonds]: '♦',
    [Suit.Clubs]: '♣',
};
/**
 * Display names for card suits.
 */
export const suitNames = {
    [Suit.Spades]: 'Spades',
    [Suit.Hearts]: 'Hearts',
    [Suit.Diamonds]: 'Diamonds',
    [Suit.Clubs]: 'Clubs',
};
/**
 * Get the color for a suit (red or black).
 */
export function getSuitColor(suit) {
    return suit === Suit.Hearts || suit === Suit.Diamonds
        ? colors.suit.hearts
        : colors.suit.spades;
}
/**
 * Check if a suit is red (Hearts or Diamonds).
 */
export function isRedSuit(suit) {
    return suit === Suit.Hearts || suit === Suit.Diamonds;
}
/**
 * SVG viewBox dimensions for suit icons.
 */
export const SUIT_VIEWBOX = '0 0 24 24';
/**
 * Get all rendering data for a suit icon.
 */
export function getSuitIconData(suit) {
    return {
        suit,
        path: suitPaths[suit],
        color: getSuitColor(suit),
        symbol: suitSymbols[suit],
        name: suitNames[suit],
        viewBox: SUIT_VIEWBOX,
        isRed: isRedSuit(suit),
    };
}
//# sourceMappingURL=SuitIcon.js.map